import fileSize from 'filesize';

export const formatSize = (sizeInBytes: number) => fileSize(sizeInBytes);
